export const i18n_langs = ['en-us', 'zh-cn', 'zh-hk', 'ru-ru', 'tr-tr', 'ja-jp', 'fr-fr', 'de-de', 'es-es', 'hi', 'vi-vi', 'ko-kr', 'pl-pl']


export const browserLangToStandard = (lang: any) => {
  const lowerLang = lang.toLowerCase();
  // console.log("lowerLang", lowerLang);
  // 定义语言映射
  const languageList = [
    { key: "de-DE", language: "德语", includes: ["de", "de-DE", "de-AT", "de-CH"] },
    { key: "en-US", language: "英语", includes: ["en", "en-US", "en-GB", "en-AU", "en-CA", "en-NZ", "en-IE", "en-IN"] },
    { key: "es-ES", language: "西班牙", includes: ["es", "es-ES", "es-MX", "es-AR", "es-CO", "es-CL", "es-PE"] },
    { key: "fr-FR", language: "法语", includes: ["fr", "fr-FR", "fr-CA", "fr-BE", "fr-CH", "fr-LU"] },
    { key: "hi", language: "印度", includes: ["hi", "hi-IN"] },
    { key: "ja-JP", language: "日语", includes: ["ja", "ja-JP"] },
    { key: "ko-KR", language: "韩语", includes: ["ko", "ko-KR"] },
    { key: "pl-PL", language: "波兰", includes: ["pl", "pl-PL"] },
    { key: "ru-RU", language: "俄罗斯", includes: ["ru", "ru-RU"] },
    { key: "tr-TR", language: "土耳其", includes: ["tr", "tr-TR"] },
    { key: "vi-VI", language: "越南", includes: ["vi", "vi-VN"] },
    { key: "zh-HK", language: "繁体", includes: ["zh-TW", "zh-HK", "zh-MO", "zh-Hant"] },
    { key: "zh-CN", language: "简体", includes: ["zh","zh-CN", "zh-SG", "zh-Hans"] }
  ];

  // 精确匹配 includes 列表
  for (const item of languageList) {
    if (item.includes.map(l => l.toLowerCase()).includes(lowerLang)) {
      return item.key;
    }
  }

  // 尝试匹配前两位语言码
  const shortLang = lowerLang.split("-")[0];
  for (const item of languageList) {
    if (item.includes.map(l => l.toLowerCase()).some(l => l.startsWith(shortLang))) {
      return item.key;
    }
  }

  // 如果没有匹配，返回默认语言
  return 'en-us';
};

export const getBrowserLang = () => {
  // console.log("navigator.language", navigator.language, navigator);
  const browserLang = (navigator.language || navigator.languages[0]);
  return browserLangToStandard(browserLang)
}